/**
 * Scroll Animations using GSAP ScrollTrigger
 */

import { debounce } from "../helpers/debounce";
import { getSafeVimeoEmbedUrl } from "../helpers/vimeo";

export class ScrollAnimations {
  constructor() {
    this.init();
  }

  /**
   * Initialize animations
   */
  init() {
    if (
      typeof gsap === "undefined" ||
      typeof ScrollTrigger === "undefined" ||
      typeof SplitText === "undefined"
    ) {
      console.warn("GSAP, ScrollTrigger, or SplitText not loaded");
      return;
    }

    gsap.registerPlugin(ScrollTrigger, SplitText);

    ScrollTrigger.config({
      ignoreMobileResize: true,
    });

    this.mm = gsap.matchMedia();

    this.stickyMenu();
  }

  stickyMenu() {
    const stickyMenu = document.querySelector(".wps-header-sticky-menu");
    if (!stickyMenu) return;

    let lastScroll = 0;
    let isVisible = false;

    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;

      if (currentScroll > 200 && currentScroll < lastScroll) {
        if (!isVisible) {
          isVisible = true;

          stickyMenu.classList.add("active");
        }
      }

      if (currentScroll > lastScroll) {
        if (isVisible) {
          isVisible = false;

          stickyMenu.classList.remove("active");
        }
      }

      if (currentScroll <= 200) {
        stickyMenu.classList.remove("active");

        isVisible = false;
      }

      lastScroll = currentScroll;
    });
  }
}
